<template>
  <el-dialog
    :visible.sync="show"
    width="600px"
    append-to-body
    title="临时短信充值"
    :before-close="closeDialog"
  >
    <el-form class="form-box" ref="form" :model="submit_data" :rules="rules">
        <el-form-item label="用户名：" prop="user_name" label-position="right" label-width="100px">
            <el-input style="width: 180px" v-model="submit_data.user_name" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="选择城市：" prop="city_tag" label-position="right" label-width="100px">
            <el-select
                v-model="submit_data.city_tag"
                filterable
                placeholder="请选择城市"
                style="width: 180px"
                @change="cityChange"
            >
            <el-option-group
                v-for="group in city_data"
                :key="group.label"
                v-if="group[0].alias != '主库'"
                :label="group[0].alias"
            >
                <el-option v-for="item in group" :key="item.city_tag" :label="item.include" :value="item.city_tag">
                </el-option>
            </el-option-group>
        </el-select>
        </el-form-item>
        <el-form-item label="充值金额：" prop="amount" label-position="right" label-width="100px">
            <!-- <el-tag size="medium" effect="dark">100条/8元</el-tag> -->
             <el-radio-group v-model="submit_data.amount">
                <el-radio label="8" border>100条/8元</el-radio>
                <el-radio label="16" border>200条/16元</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item align="center">
            <el-button type="primary" @click="submitForm">立即充值</el-button>
        </el-form-item>



      <div v-if="wxpayUrl">
      <div
        style="display: flex; align-items: center; flex-direction: column;"
      >
        <h1 style="font-size: 30px; color: #05c0ab">微信扫一扫支付</h1>
        <el-image
          :src="wxpayUrl"
          v-loading="loading"
        >
          <div slot="error">加载中<span class="dot">...</span></div>
        </el-image>
        <div>注：若二维码过期失效，请重新打开页面进行支付！</div>
      </div>
      </div>
    </el-form>

  </el-dialog>
</template>
<script>
var _this;
let myTimer;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置
export default {
    props: {
        isShow: Boolean,
        data: '',
        type: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;

            // _this.getQrcode();
            // _this.default100(); //打开页面，充值默认为300；
        }
    },
    data() {
        return {
            timeModel: '',
            loading: true,
            city_tag: '',
            city_data: [],

            total_money: '',
            wxpayUrl: '',
            trade_no: '',

            show: false,


            // 表单数据
            submit_data: {
                user_name: '',
                city_tag: '',
                amount: '8',
                type: 0,
                pay_type: '1',

            },
            rules: {
                user_name: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                city_tag: [
                    { required: true, message: '请选择城市', trigger: 'change' }
                ]
            },
        };
    },
    created() {
        _this = this;
        if (_this.city_data.length == 0) {
            axios.defaults.baseURL = config.axios_normalURL; //请求normalURL
            _this
                .$post('/city/getCityLists', {}, {}, 'normal')
                .then((res) => {
                    _this.city_data = res.data;

                    axios.defaults.baseURL = config.axios_baseURL; //请求base url
                })
                .catch((err) => {});
            axios.defaults.baseURL = config.axios_baseURL; //请求base url
        }
    },

    methods: {

        // 城市选中事件
        cityChange(val) {
            // 设置city_tag
            this.submit_data.city_tag = val;
            localStorage.setItem('city_tag', val);
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.getQrcode();
                } else {
                    console.log('校验失败');
                    return false;
                }
            });
        },

        //获取充值二维码
        onSubmit(pay_type) {
            if(pay_type){
                this.submit_data.pay_type = pay_type;
            }

            _this.$post('/service_fee/rechargeSMS', this.submit_data).then((res) => {
                this.closeDialog();
            });
        },


        getQrcode() {
            this.loading = true;
            this.$post('/service_fee/loginRechargeSMS', this.submit_data).then((res) => {
                this.wxpayUrl = res.data.qr_img;
                this.loading = false;
                this.trade_no = res.data.req_seq_id;
                this.getPayStatus();
            });
        },

        getPayStatus() {
            // axios.defaults.baseURL = config.axios_normalURL;
            this.$post('/service_fee/loginPayStatus', {
                req_seq_id: this.trade_no,
                city_tag: this.submit_data.city_tag
            }).then((res) => {
                // axios.defaults.baseURL = config.axios_baseURL;
                if (res.data.status == 0) {
                    // 支付未完成
                    this.timeModel = setTimeout(() => {
                        this.getPayStatus();
                    }, 3000);
                } else {
                    this.$message({
                        type: 'success',
                        message: '支付成功'
                    });
                    // 支付完成
                    this.closeDialog();
                }
            });
            // axios.defaults.baseURL = config.axios_normalURL;
        },

        // 关闭方法
        closeDialog() {
            clearTimeout(this.timeModel);
            _this.show = false;
            // _this.rechargeData= ['300', '500', '800', '1000', '1500', '2000', '3000'],
            // _this.give_amount = '';
            _this.wxpayUrl = '';
            this.trade_no = '';

            // this.$emit('onSubmit');
            // for (const key in _this.submit_data) {
            //     _this.submit_data[key] = '';
            // }
            // this.btnChangeIndex = '0';
        }
    }
};
</script>
<style scoped>
.recharge-btn {
    display: flex;
}
.form-box {
    padding: 0 20px;
    box-sizing: border-box;
    width: 100%;
}

.recharge-span {
    width: 100px;
    font-size: 18px;
    margin: 10px 0;

}
.submit-btn {
    display: block;
    margin: 20px auto;
    width: 100%;
}
/deep/.el-dialog__header {
  background: #05C0AB;
  padding: 20px;
  font-size: 16px;
  color: #fff;
  text-align: left;

}
/deep/.el-dialog__title {
  color: #fff;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
</style>
<style>
.recharge-btn .el-button--info {
    border: 1px solid #05c0ab;
    background-color: #fff;
    color: #05c0ab;
}
.form-box .el-image__inner {
    width: 220px;
}
</style>

